import { LineStyleValue } from "constants/chart.constants";
import styled from "styled-components";

interface LineStylePreviewProps {
  style: LineStyleValue;
  width?: number;
  height?: number;
  color?: string;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Renders an SVG preview of a dash pattern for use in the line style picker and product buttons.
 */
export function LineStylePreview({
  style,
  width = 50,
  height = 5,
  color = "currentColor",
  onClick
}: LineStylePreviewProps) {
  return (
    <Wrapper onClick={onClick} $height={height}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke={color}
          strokeWidth={height}
          strokeDasharray={style === "solid" ? undefined : style.join(",")}
        />
      </svg>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $height: number }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: calc(${({ $height }) => $height}px + 6px); // add height for easier clicking

  &:hover svg {
    color: var(--color-primary-hover) !important;
  }
`;
